module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAAAtBAMAAADcoWFIAAAAFVBMVEUAAACMjIyIiIiIiIiJiYmIiIiIiIjeJZqWAAAABnRSTlMAJeX0PdWouqMGAAAApUlEQVRIx43MsQkCARTA0C84wOkGWriAh7WgMziA4u0/gmUaIUmZ4s3utU7r8V1md/ncp7S/vZeZ47Y2ejvNgBcaPNDgiQZ3GrzS4E6DOw1eaXCnwZ12HNpx6IpDOw7tOLTj0BWHdhzacWjHoSsO7Ti049COQ1cc2nFox6Edh644tOPQjkM7Dh1xaMehEw5dcOiCP6EDfoUO+AYdcOiCn6FDh//7B96wPUy+83YwAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/updown-icon.png
// module id = 1107
// module chunks = 85